import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
} from "reactstrap"
import Select from "react-select"
import { Link, useHistory } from "react-router-dom"
import { get, post } from "../../helpers/api_helper"
import * as url from "../../helpers/url_helper"
import moment from 'moment';
import { connect } from "react-redux"

import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';

const AssetStatusLog = props => {

  const [selectedDateOption, setSelectedDateOption] = React.useState({ label: 'weekly', value: 'weekly' });
  const [startDate, setStartDate] = React.useState(moment().subtract(1, 'week').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = React.useState(moment().format('YYYY-MM-DD'));

  const [data, setData] = React.useState([]);

  const [errors, setErrors] = React.useState([]);
  
  const [loading, setLoading] = React.useState(true);

  const dateOptions = [
    { label: 'Today', value: 'today' },
    { label: 'Yesterday', value: 'yesterday' },
    { label: 'Weekly', value: 'weekly' },
    { label: 'Monthly', value: 'monthly' }
  ];

  const columns = [{
    dataField: 'slno',
    text: '#',
    sort: true,
  },
  {
    dataField: 'asset.name',
    text: 'Asset name',
    // formatter: () => '-',
    sort: true,
    filter: textFilter(),
  }, 
  {
    dataField: 'previous',
    text: 'Previous Status',
    // formatter: () => '-',
    sort: true,
    filter: textFilter(),
  }, 
  {
    dataField: 'current',
    text: 'Current Status',
    sort: true,
    filter: textFilter(),
  }, 
  {
    dataField: 'daily_tasks',
    text: 'Daily tasks affected',
    sort: true,
    filter: textFilter(),
  }, 
  {
    dataField: 'ppm_tasks',
    text: 'PPM Tasks affected',
    sort: true,
    filter: textFilter(),
  }, 
  {
    dataField: 'created_at',
    text: 'Date & time',
    sort: true,
    filter: textFilter(),
    formatter: (cell, row, rowIndex) => (moment(cell).format('DD MMM YYYY hh:mm a') || '-'),
    filterValue: (cell, row, rowIndex) => (moment(cell).format('DD MMM YYYY hh:mm a') || '-'),
    csvFormatter: (cell, row, rowIndex) => (moment(cell).format('DD MMM YYYY hh:mm a') || '-'),
  }, 
  {
    dataField: 'user.name',
    text: 'Done by',
    sort: true,
    filter: textFilter(),
  }, 
  {
    dataField: 'remarks',
    text: 'Remark',
    sort: true,
    filter: textFilter(),
  }, 
  ];

  const handleSubmit = () => {

    if(moment(endDate) < moment(startDate)) {
      cogoToast.error('End date cannot be before Start date');
      return;
    }

    let data = {
      'start_date': startDate,
      'end_date': endDate,
      // property_id: props.filterProperty.id,
      'block_id': props.filterBlock.id,
    };

    console.log('data', data);

    setLoading(true);
    setErrors([]);

    post(url.POST_ASSETSTATUSLOG, data)
    .then((response) => {
      console.log('RESP', response.data);
      if(response.status == 200) {
        setData(response.data)
      }
      else if(response.status == 400) {
        setErrors(Object.values(response.error));
      }
      else {
        console.log('err::', response);
      }
    }, (error) => {
      console.log(error);
      setLoading(false);
    });
  };



  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Asset Status Log | Digital Logbook</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-4">Asset Status Log</h3>
            {/* <Link className="btn btn-secondary" to="/activities/index">Back</Link> */}
          </div>

          <Card>
            <CardBody>
              {/* <CardTitle tag="h3">BASIC DETAILS</CardTitle> */}
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <div className="row">
                <div className="col">
                  <div className="">
                    <label className="label form-label">&nbsp;</label>
                    <Select
                        classNamePrefix="select2-selection"
                        placeholder="Select one..."
                        title="Set to..."
                        options={dateOptions}
                        value={selectedDateOption}
                        onChange={e => { 
                          if(e.value == 'today') {
                            setStartDate(moment().format('YYYY-MM-DD'));
                            setEndDate(moment().format('YYYY-MM-DD'));
                          }
                          else if(e.value == 'yesterday') {
                            setStartDate(moment().subtract(1, 'day').format('YYYY-MM-DD'));
                            setEndDate(moment().subtract(1, 'day').format('YYYY-MM-DD'));
                          }
                          else if(e.value == 'weekly') {
                            setStartDate(moment().subtract(1, 'week').format('YYYY-MM-DD'));
                            setEndDate(moment().format('YYYY-MM-DD'));
                          }
                          else if(e.value == 'monthly') {
                            setStartDate(moment().subtract(1, 'month').format('YYYY-MM-DD'));
                            setEndDate(moment().format('YYYY-MM-DD'));
                          }
                            setSelectedDateOption(e); 
                        }}
                        />
                  </div>
                </div>
                <div className="col">
                  <div className="">
                    <label className="label form-label">From</label>
                    <input type="text" className="form-control" id="dateFrom"
                      type="date"
                      value={startDate} onChange={e => { 
                        setStartDate(e.target.value); 
                        setSelectedDateOption(null);
                      }}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="">
                    <label className="label form-label">To</label>
                    <input type="text" className="form-control" id="dateFrom"
                      type="date"
                      value={endDate} onChange={e => { 
                        setEndDate(e.target.value); 
                        setSelectedDateOption(null);
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-center mt-4">
                <button type="button" className="btn btn-primary" onClick={() => { handleSubmit(); }}>Generate</button>
              </div>

            </CardBody>
          </Card>

          <Card>
            <CardBody>
              {data && data.length > 0 ?
              <div>
                    <BootstrapTable striped
                        bordered={false}
                        wrapperClasses="table-responsive" 
                        className="border border-danger"
                        keyField='id'
                        data={ data }
                        columns={ columns } 
                        filter={ filterFactory() } 
                        pagination={ paginationFactory() } 
                        />
              </div>
              :
              <div className="text-muted py-5 text-center">No data</div>
              }
              {/* <CardTitle tag="h3">Forms</CardTitle> */}
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              
            </CardBody>
          </Card>

     </Container>

      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  const {
    filterBlock,
    filterProperty
  } = state.filters
  return { filterBlock, filterProperty }
}

export default connect(mapStatetoProps)(AssetStatusLog)